  // $(document).ready(function(){
  //   $('.quickadd_btn-ctm').click(function(){
  //     var var_opt = $(this).parents('custom__collection__grid-buttons__ctm');
  //     console.log(var_opt);
  //    var child_element = $(var_opt).children('.custom__variant--picker');
  //    console.log(child_element);
  //    if  ($(child_element).hasClass('custom__check')) {
  //     $(child_element).css('display', 'flex');
       
  //     };
  //   });
  // });

    $(document).ready(function () {
  const GallerySwiper = new Swiper('#content-image-gallery .swiper', {
    slidesPerView: 1,
    spaceBetween: 3,
    centeredSlides: true,
 
    loop: true,
    preloadImages: false,
    lazy: {
      enabled: true,
      checkInView: true,
      loadPrevNext: true,
      loadPrevNextAmount: 2,
    },
    navigation: {
      nextEl: "#content-image-gallery .swiper-button-next",
      prevEl: "#content-image-gallery .swiper-button-prev",
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 0,
        touchStartForcePreventDefault: true,
        allowTouchMove: false,
        preventClicks: true,
        speed: 1000,
      },
    },
  });
      $('.additional-video video').get(0).play();
});

$(document).on('click','.swiper-backface-hidden .swiper-slide', function(){
  if (window.innerWidth < 1024){
    $('content-image-gallery .swiper-gallery').addClass('swiper-gallery-fullscreen');
  }
});
$('button.swiper-toggle-fullscreen.absolute').on('click', function(){
  if (window.innerWidth < 1024){
      console.log('clicked:',  $('content-image-gallery .swiper-gallery'));
    
   let fullScreenModeOn =  $('content-image-gallery .swiper-gallery').hasClass('swiper-gallery-fullscreen');
   if (fullScreenModeOn === true ){
     console.log('here');
     $('content-image-gallery .swiper-gallery').removeClass('swiper-gallery-fullscreen')
   }
  }
});
